import { defineComponent as _defineComponent } from 'vue'
import { useTab } from '~/composables';
import { computed } from 'vue';

interface Props {
  name: string;
  text?: string;
  link?: string | any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiTab',
  props: {
    name: null,
    text: { default: '' },
    link: { default: '' }
  },
  setup(__props: any) {

const props = __props as { name: string, text: string, link: string | any };


const tab = computed(() => ({
  name: props.name,
  text: props.text || props.name,
  link: props.link,
}));

const { isActive } = useTab(tab as any);

return { __sfc: true,props, tab, isActive }
}

})